const Base64ToBlobV2 = (base64, sliceSize = 1024) => {
  // Remove prefixos do tipo:
  // data:application/pdf;base64,...
  const cleanBase64 = base64.includes(",") ? base64.split(",")[1] : base64;

  const byteCharacters = atob(cleanBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  // Retorna diretamente um Blob
  return new Blob(byteArrays, { type: "application/octet-stream" });
};

export default Base64ToBlobV2;
